import { CommonModule, NgComponentOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Signal,
  signal,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { ReferralComponent } from '@blaze-dashboard/referral-feature';
import { UserInfo } from '@blaze-shared/api-contracts-domain';
import { fromRouter, ProjectContextFacade } from '@blaze-shared/app-state-data-access';
import {
  AccountSwitcherComponent,
  HeaderComponent,
  HelpdeskButtonComponent,
} from '@blaze-shared/shared-feature';

import { ActionBarUserComponent } from '../action-bar-user/action-bar-user.component';

@Component({
  selector: 'blaze-action-bar',
  imports: [
    AccountSwitcherComponent,
    ActionBarUserComponent,
    CommonModule,
    HeaderComponent,
    HelpdeskButtonComponent,
    NgComponentOutlet,
    ReferralComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss'],
})
export class ActionBarComponent {
  private readonly projectContextFacade = inject(ProjectContextFacade);
  private readonly store = inject<Store<any>>(Store);

  protected user = signal<UserInfo | null>(null);
  protected isReferralEnabled: Signal<boolean>;

  readonly actionBarComponent$ = this.store
    .select(fromRouter.getMergedData)
    .pipe(map((data) => data?.['actionBar']));

  constructor() {
    this.projectContextFacade.userInfo$.subscribe((userInfo) => {
      if (userInfo) {
        this.user.set(userInfo);
      }
    });

    this.isReferralEnabled = computed(
      () => !!this.projectContextFacade.account()?.showReferralInfo,
    );
  }
}
